export default {
	pageName: "ViewCreateGoalJob",
};
